<div class="modal-header">
  <div class="modal-branding-content">
    <span class="modal-header-branding-text">Download the Latest Electrical Standards</span>
  </div>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body py-2">
  <div class="container">
    <div class="row mb-3">
      <div class="col-12 d-flex gap-2">
        <div class="input-group flex-grow-1">
          <input
            type="text"
            class="form-control"
            placeholder="Search standards..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchTermChanged()"
            (keyup.enter)="loadStandards(true)"
          />
          <div class="input-group-append">
            <span class="input-group-text" *ngIf="searchLoading || isLoading">
              <i class="fa fa-spinner fa-spin mx-2"></i>
              <small>{{ searchLoading ? 'Searching' : 'Loading' }}</small>
            </span>
            <span class="input-group-text" *ngIf="!(searchLoading || isLoading)">
              <i class="fa fa-search mx-2"></i>
              <small>Search</small>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading && hasError" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div>

    <div *ngIf="!isLoading && !hasError && standards.length === 0" class="text-muted text-center py-4">
      No standards found.
    </div>

    <div *ngIf="standards.length > 0" class="container">
      <div *ngFor="let standard of standards" class="standard-item">
        <div class="d-flex justify-content-between align-items-center py-4 border-bottom">
          <div class="d-flex flex-column flex-grow-1">
            <div class="d-flex align-items-center gap-2 mb-2">
              <strong>{{ standard.title }}</strong>
            </div>

            <div class="text-muted">
              {{ standard.description }}
            </div>
          </div>

          <div class="mx-4 standard-item-actions">
            <a href="javascript:void(0)" (click)="getStandardUrl(standard.id)" rel="noopener noreferrer" class="text-decoration-none fw-semibold">
              View PDF
            </a>
          </div>
        </div>
      </div>

      <div class="text-center py-3" *ngIf="canLoadMore">
        <button class="btn btn-outline-primary" type="button" (click)="loadMoreStandards()" [disabled]="searchLoading || isLoading">
          <span *ngIf="!searchLoading && !isLoading">{{ 'LoadMore' }}</span>
          <span *ngIf="searchLoading || isLoading">
            <i class="fa fa-spinner fa-spin"></i> {{ searchLoading ? 'Searching' : 'Loading' }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>